module.exports = "/packs/images/svg/facilities/e_resource~53217adfbe670c38ca74101e307d3741.svg";